import { render, staticRenderFns } from "./PlatformPlanSelectorDialog.vue?vue&type=template&id=05b60a3c&"
import script from "./PlatformPlanSelectorDialog.vue?vue&type=script&lang=js&"
export * from "./PlatformPlanSelectorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports